import { Checkbox, Menu, MenuItem, Typography } from '@mui/material';
import {
  ConversationChannelType,
  ConversationParticipantEntity,
} from '@provision/conversation-types';
import { useMemo } from 'react';
import { useClientEmails } from 'src/graphql/entities/client-email';
import { ParticipantSelectorItem } from 'src/pages/Conversations/Chat/ParticipationPanel/types';

interface ParticipantChipMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  participant: ParticipantSelectorItem;
  onAddEmail: (data: ParticipantSelectorItem, email: string) => void;
  onRemoveEmail: (data: ParticipantSelectorItem, email: string) => void;
}

export const ParticipantChipMenu = (props: ParticipantChipMenuProps) => {
  const { anchorEl, onClose } = props;

  const handleEmailClick = (email: string) => {
    const existingChannel = props.participant.channels.find(
      (channel) => channel.externalIdentifier === email,
    );

    if (existingChannel) {
      props.onRemoveEmail(props.participant, email);
      return;
    }
    props.onAddEmail(props.participant, email);
  };

  const { clientEmails } = useClientEmails({
    clientId:
      props.participant.participantEntity === ConversationParticipantEntity.Client
        ? props.participant.participantIdentity
        : '',
  });

  const preparedEmails = useMemo(() => {
    const result = new Set(clientEmails.map((record) => record.value));

    props.participant.channels.forEach((channel) => {
      if (
        (channel.conversationChannelTypeId as ConversationChannelType) ===
        ConversationChannelType.Email
      ) {
        result.add(channel.externalIdentifier);
      }
    });

    return Array.from(result);
  }, [clientEmails, props.participant.channels]);

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Typography sx={{ paddingLeft: '1rem' }} variant="caption">
        Emails
      </Typography>
      {preparedEmails.map((email) => (
        <MenuItem
          key={email}
          onClick={() => handleEmailClick(email)}
          sx={{
            maxWidth: '25rem',
          }}
        >
          <Checkbox
            checked={props.participant.channels.some(
              (channel) => channel.externalIdentifier === email,
            )}
            sx={{ width: '1rem', height: '1rem' }}
          />
          <Typography
            variant="body2"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            overflow="hidden"
          >
            {email}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};
